"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelocatePoleToolController = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var location_input_state_1 = require("../../../components/input/location.input.state");
var theme_1 = require("../../../components/theme");
var store_1 = require("../../../store");
var point_collection_cache_1 = require("../../topological.editor.map/point.collection.cache");
var topological_editor_tool_abstract_ctrl_1 = require("../topological.editor.tool.abstract.ctrl");
var CSS = {
    withRelocationTool: 'c-PoleRelocationTool__attached'
};
var Style = (_a = {},
    _a[CSS.withRelocationTool] = {
        cursor: 'crosshair'
    },
    _a);
(0, theme_1.addStyles)(Style);
var RelocatePoleToolController = /** @class */ (function (_super) {
    tslib_1.__extends(RelocatePoleToolController, _super);
    function RelocatePoleToolController(ctrl) {
        var _this = _super.call(this, ctrl) || this;
        _this.ctrl = ctrl;
        var editCtrl = ctrl.selectedCollectionEdit;
        _this.locationField = editCtrl.collectionEditState.collection.editableLocationField;
        ctrl.classnames.push(CSS.withRelocationTool);
        ctrl.map.map.setOptions({ draggableCursor: 'crosshair' });
        _this.makeInputState();
        _this.bindMapClickEvent();
        return _this;
    }
    RelocatePoleToolController.prototype.makeInputState = function () {
        var _this = this;
        var inputState = this.ctrl
            .selectedCollectionEdit
            .changeState
            .getState(this.locationField.id);
        if (!inputState) {
            inputState = new location_input_state_1.LocationInputState(this.locationField.schema.displayName);
            inputState.onValue(function () {
                _this.locationField.Mutator.edited(inputState.value);
            });
            this.topologicalEditorController
                .selectedCollectionEdit
                .changeState
                .addState(this.locationField.id, inputState);
            inputState.setValue(this.locationField.value);
        }
        this.inputState = inputState;
    };
    RelocatePoleToolController.prototype.bindMapClickEvent = function () {
        var _this = this;
        this.clickEventListener = this.ctrl.map.map.addListener('click', function (event) {
            var _a = event.latLng, lat = _a.lat, lng = _a.lng;
            var newLat = lat().toFixed(7);
            var newLng = lng().toFixed(7);
            _this.inputState.latitude.setInputValue(newLat);
            _this.inputState.longitude.setInputValue(newLng);
            // Next we want to update all the the other spans that are linked to this collection.
            var spans = [];
            var _loop_1 = function (collection) {
                var collectionLinkIds = [];
                // Find all linked spans (including unsaved ones)
                collection.forEachField(function (field) {
                    if (core_shared_1.CollectionModelFieldVector.isVectorField(field)
                        && field.isCollectionLink()
                        && field.getCollections()[0].revision === _this.ctrl.selectedCollection.revision) {
                        collectionLinkIds.push(field.stateValue.collectionId);
                    }
                });
                // If a collection contains a link to the collection that we are moving, then...
                if (collectionLinkIds.includes(_this.ctrl.selectedCollection.id)) {
                    var summary = store_1.AppStore.CollectionSummary.get(collection.revision);
                    // Filter out non spans & spans that are only linked to this collection
                    var vectors = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionVectors(summary.revision);
                    spans.push.apply(spans, vectors.filter(function (x) { return x.field.id.includes('spanLength') && x.field.isCollectionLink() && x.field.getCollections()[0].revision === _this.ctrl.selectedCollection.revision; }));
                }
            };
            // Loop though all the collections on screen.
            for (var _i = 0, _b = _this.ctrl.collectionModels; _i < _b.length; _i++) {
                var collection = _b[_i];
                _loop_1(collection);
            }
            for (var _c = 0, spans_1 = spans; _c < spans_1.length; _c++) {
                var span = spans_1[_c];
                span.target.latitude = newLat;
                span.target.longitude = newLng;
            }
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionLocations(_this.locationField.collection.revision);
            _this.ctrl.updateSpansDistanceBearing(_this.locationField.collection.revision);
            _this.ctrl.exitTool();
        });
    };
    RelocatePoleToolController.prototype.destroy = function () {
        this.topologicalEditorController.classnames.filter(function (x) { return x !== CSS.withRelocationTool; });
        this.topologicalEditorController.map.map.setOptions({
            draggableCursor: ''
        });
        google.maps.event.removeListener(this.clickEventListener);
    };
    return RelocatePoleToolController;
}(topological_editor_tool_abstract_ctrl_1.TopologicalEditorToolController));
exports.RelocatePoleToolController = RelocatePoleToolController;
//# sourceMappingURL=relocate.pole.js.map